export const LEVERAGE_OPTIONS = [
  { id: true, displayValue: 'Leveraged' },
  { id: false, displayValue: 'Unleveraged' },
];
